import React, { useCallback, useState } from 'react';
import { PropTypes } from 'prop-types';
import EditField from './EditField';
import WithValue from './WithValue';
import EmptyValue from './EmptyValue/';

const MiniForm = ({
  className,
  value,
  submitValue,
  id,
  labelField,
  help,
  valueLabel,
  toEditLabel,
  submitLabel,
  cancelLabel,
  editLabel,
  overrideEditField,
  isNew,
  disableEdit = false,
}) => {
  const isConfigRecurringPage =
    window.location.pathname.startsWith('/orders/recurring');
  const [isEditing, setIsEditing] = useState(false);
  const [localValue, setLocalValue] = useState(value);

  const handleSetEditing = useCallback(() => {
    setIsEditing(true);
  }, [setIsEditing]);

  const handleSetValue = useCallback(
    (val) => {
      setLocalValue(val);
    },
    [setLocalValue]
  );

  const closeEditing = useCallback(() => {
    setIsEditing(false);
  }, [setIsEditing]);

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      closeEditing();
      submitValue({ value: localValue });
    },
    [submitValue, closeEditing, localValue]
  );

  const renderEditing = () => {
    return overrideEditField ? (
      React.cloneElement(overrideEditField, {
        ...overrideEditField.props,
        onCancel: closeEditing,
        isEditing: true,
      })
    ) : (
      <EditField
        id={id}
        onChange={(_, { value: val }) => handleSetValue(val)}
        labelField={labelField}
        value={localValue}
        help={help}
        submitAction={handleSubmit}
        submitLabel={submitLabel}
        cancelAction={closeEditing}
        cancelLabel={cancelLabel}
      />
    );
  };

  const renderReading = () => {
    if (value) {
      return overrideEditField ? (
        React.cloneElement(overrideEditField, {
          ...overrideEditField.props,
          onCancel: closeEditing,
        })
      ) : (
        <WithValue
          isConfigRecurringPage={isConfigRecurringPage}
          valueLabel={valueLabel}
          value={value}
          editButtonAction={handleSetEditing}
          editIcon="edit"
          editLabel={editLabel}
          disableEdit={disableEdit}
        />
      );
    }

    if (isConfigRecurringPage) return <></>;

    return (
      <EmptyValue
        setEdit={handleSetEditing}
        toEditLabel={toEditLabel}
        isNew={isNew}
      />
    );
  };

  return (
    <div className={className} data-testid="mini-form">
      {isEditing ? renderEditing() : renderReading()}
    </div>
  );
};

MiniForm.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  submitValue: PropTypes.func.isRequired,
  isEditing: PropTypes.bool,
  id: PropTypes.string,
  labelField: PropTypes.string,
  help: PropTypes.string,
  valueLabel: PropTypes.string,
  toEditLabel: PropTypes.string,
  submitLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  editLabel: PropTypes.string,
  overrideEditField: PropTypes.node,
  isNew: PropTypes.bool,
};

MiniForm.defaultProps = {
  isEditing: false,
  isNew: false,
};

export default MiniForm;
